import './ratingsText.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/RatingsText/index.js